module.exports = __webpack_public_path__ + "static/media/delaware-river-watershed.b8456fd3.md";